import React, {useEffect} from 'react';
import {useStore} from "@/app/providers/StoreProvider";
import {observer} from "mobx-react-lite";

export const RatingTabs = observer(() => {

    const {ratingStore} = useStore();

    const {ratingTabs, currentTab} = ratingStore;

    useEffect(() => {
        const fetchRating = async () => {
            await ratingStore.getRatingTabs();
        }
        if (ratingStore.ratingTabs.length == 0) {
            fetchRating()
        }
    }, []);

    return (
        <div className='tabs'>
            {ratingTabs.map((ratingTab, index) => (
                <div className={`tab ${currentTab === ratingTab.ratingId ? 'active' : ''}`}
                     onClick={() => ratingStore.changeTab(ratingTab.ratingId)}>{ratingTab.ratingLexem}</div>
            ))}
        </div>
    );
});
